import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spin-dot-holder">
        <span className="spin-dot-item"></span>
        <span className="spin-dot-item"></span>
        <span className="spin-dot-item"></span>
        <span className="spin-dot-item"></span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
